import React, { useEffect } from 'react';
import './XLanding.css';

const XLanding = () => {
  useEffect(() => {
    // Parse and log attribution params
    const params = new URLSearchParams(window.location.search);
    const attribution = {
      src: params.get('src') || 'direct',
      card: params.get('card'),
      pick: params.get('pick'),
      content: params.get('content'),
      variant: params.get('v') || 'unknown',
      timestamp: new Date().toISOString(),
      referrer: document.referrer
    };
    
    // Log to console (replace with analytics endpoint)
    console.log('X Landing Attribution:', attribution);
    
    // Store in localStorage for session tracking
    localStorage.setItem('x_attribution', JSON.stringify(attribution));
    
    // Optional: Send to analytics endpoint
    fetch('https://0j2sk3d3ol.execute-api.us-east-1.amazonaws.com/prod/api/analytics/pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: 'x_landing', ...attribution })
    }).catch(() => {}); // Silent fail
  }, []);

  return (
    <div className="x-landing">
      <div className="x-landing-container">
        <div className="x-landing-logo">🧭</div>
        <h1 className="x-landing-headline">BetPilot</h1>
        <p className="x-landing-tagline">Your AI betting co-pilot</p>
        
        <div className="x-landing-value">
          <p>Quant-driven edges. No hype.</p>
          <p className="x-landing-subtext">
            We show our work: fair probability, expected value, and risk on every pick.
          </p>
        </div>

        <div className="x-landing-ctas">
          <a href="/edges" className="x-landing-btn primary">
            Open Today's Picks
          </a>
          <a href="/chat" className="x-landing-btn secondary">
            Try the AI Chat
          </a>
        </div>

        <footer className="x-landing-footer">
          For entertainment only.
        </footer>
      </div>
    </div>
  );
};

export default XLanding;
